import React, { Suspense, useState } from 'react';
import PropTypes from 'prop-types';
import { SubsectionContainer } from '../CourseHome.styles';
import PresentationIcon from '../../../Visuals/Icons/PresentationIcon.icon';
import PDFViewer from '../PdfViewer.component';
import { useMediaQuery } from 'react-responsive';
import TertiaryButtonComponent from '../../../Components/Buttons/TertiaryButton/TertiaryButton.component';

const PresentationContainer = ({ data }) => {
  const [showIframe, setShowIframe] = useState(false);
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  return (
    <>
      <SubsectionContainer id="presentation">
        <Suspense fallback={<div>Loading icon...</div>}>
          <PresentationIcon />
        </Suspense>
        <h3
          style={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          Presentation{' '}
          {!isMobile && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <p>Presentation not working?</p>
              <TertiaryButtonComponent
                functionName={() => setShowIframe(!showIframe)}
                span={showIframe ? 'Hide Fallback' : 'Show Fallback'}
              />
            </div>
          )}
        </h3>
      </SubsectionContainer>
      <Suspense fallback={<div>Loading PDF viewer...</div>}>
        <PDFViewer pdfUrl={data?.pdf} showIframe={showIframe} />
      </Suspense>
    </>
  );
};
PresentationContainer.propTypes = {
  data: PropTypes.shape({
    pdf: PropTypes.string,
  }),
};

export default PresentationContainer;
